import { FC } from "react";

import { Alert, Button } from "@livechat/design-system-react-components";

import { HelpCenter } from "constants/help-center";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { useAgentFlag } from "hooks/use-agent-flag";

export const MergeTicketBanner: FC = () => {
  const [bannerClosedFlag, setBannerClosedFlag] = useAgentFlag("closedMergingModalBanner");

  const handleClose = (): void => {
    setBannerClosedFlag(true);
    trackEngagement("Ticket: Merging tickets closed info banner", EventPlace.Tickets);
  };

  if (bannerClosedFlag) {
    return null;
  }

  return (
    <Alert onClose={handleClose}>
      The ticket merging process is irreversible. Once it&apos;s done, all <b>tags</b>, <b>followers</b>, and&nbsp;
      <b>people in the loop</b> from the sub tickets will be added to the main ticket details. After merging, all sub
      tickets will be closed.&nbsp;
      <Button kind="link" target="_blank" rel="nofollow noreferrer noopener" href={HelpCenter.HOW_TO_MERGE_TICKETS}>
        Learn More
      </Button>
    </Alert>
  );
};
